export default __webpack_public_path__ + "static/2-e1e0bfa92758b25de28dff4816414547.png";